import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { TextComponent } from '@app/components/text/text.component';
import { TextTranslatePipe } from '@app/pipes/text-translate.pipe';
import { LanguageService, NavigationService } from '@app/services';
import { ActivatedRoute } from '@angular/router';
import { BackNavigationService } from '@app/services/back-navigation';

@Component({
  selector: 'app-header-back-button',
  templateUrl: './header-back-button.component.html',
  styleUrl: './header-back-button.component.scss',
  imports: [
    TextComponent,
    TextTranslatePipe,
  ],
  host: {
    'role': 'button',
    '(click)': 'onClick($event)',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderBackButtonComponent {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly backNavigation = inject(BackNavigationService);
  private readonly languageService = inject(LanguageService);
  private readonly navigationService = inject(NavigationService);

  protected readonly label = toSignal(this.navigationService.config$.pipe(
    map(({ backButton }) => backButton.label),
  ));

  protected readonly currentLanguage = toSignal(this.languageService.currentLanguage$, {
    requireSync: true,
  });

  protected onClick($event: MouseEvent) {
    $event.stopPropagation();

    this.backNavigation.back(this.activatedRoute.snapshot.queryParamMap.getAll('ref'));
  }

}
